import React from 'react';
import './skeleton.css';

const SellerSpinner = ({ size = 'medium', text = 'Caricamento...' }) => {
  return (
    <div className="seller-spinner-container">
      <div className={`seller-spinner seller-spinner-${size}`}>
        <div className="seller-spinner-circle"></div>
      </div>
      {text && <p className="seller-spinner-text">{text}</p>}
    </div>
  );
};

export default SellerSpinner; 